<!-- Dialog Condición -->
<div class="guardar-dialog condicion-dialog dialog-bordered"
     [ngClass]="{ 'dark-theme': isDark, 'light-theme': !isDark }"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragDisabled]="!ventana.flotante"
     [class.ventana-flotante]="ventana.flotante" [class.ventana-minimizada]="ventana.isMinimized">

  <!-- Header alineado -->
  <div class="guardar-header d-flex align-items-center justify-content-between header-bordered ventana-asa" cdkDragHandle>
    <h2 class="guardar-title ventana-titulo m-0">
      {{ data.condicion.idindicador ? 'Editar' : 'Nueva' }} Condición
    </h2>
    <div class="d-flex align-items-center ms-2">
      <button mat-icon-button class="close-button ventana-btn-minimizar" *ngIf="ventana.flotante" (click)="ventana.toggle()"
              [title]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'" [attr.aria-label]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'">
        <mat-icon>{{ ventana.isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
      </button>
      <button mat-icon-button class="close-button" (click)="onCancel()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Contenido -->
  <div class="guardar-content pt-2">
    <form [formGroup]="condicionForm" class="condicion-form w-100">
      <mat-form-field appearance="outline" class="condicion-field w-100 mb-3">
        <mat-label>Condición</mat-label>
        <div class="condition-input-container d-inline-flex flex-wrap align-items-center">
          <ng-container *ngFor="let part of conditionParts; let i = index">
            <span *ngIf="!part.isNumber" class="fixed-text px-1">{{ part.value }}</span>
            <input *ngIf="part.isNumber"
                   matInput
                   type="number"
                   class="number-only-input px-1"
                   [formControlName]="getNumberControlName(i)">
          </ng-container>
        </div>
        <input matInput formControlName="label" style="display:none;">
        <mat-error *ngIf="condicionForm.get('label')?.hasError('required')">
          La condición es requerida
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Acciones -->
  <div class="guardar-actions d-flex justify-content-end gap-2 mt-2">
    <button mat-button (click)="onCancel()" [disabled]="loading">Cancelar</button>
    <button mat-raised-button color="primary"
            (click)="onSubmit()"
            [disabled]="loading || condicionForm.invalid">
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <span *ngIf="!loading">Guardar</span>
    </button>
  </div>
</div>